// export let BASE_URL="http://localhost:4650/api"
// export let BASE_URL = "https://developer-beta.com/p7/ats/public/api"
export let BASE_URL = "https://www.brainwareuniversityhr.in/admin/api"
//export let BASE_URL = "http://127.0.0.1:8000/api"
// export let BASE_IMAGE_URL="http://localhost:4650/uploads"
export let BASE_IMAGE_URL = "http://localhost:3000/src/Assets"